import React from "react";
import { Grid, Loading } from "@sumprio/ui";

export default function ContentAreaLoadingFallback() {
  return (
    <Grid
      display="flex"
      alignItems="center"
      justifyContent="center"
      flex={1}
      width="100%"
      style={{ minHeight: 240 }}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <Loading variant="lineSpinner" size="lg" />
    </Grid>
  );
}
